import type { EmbedChatRequestHeaders } from "@nexus/types/api-envelope"

/**
 * The header map a chat request hands to `fetch`, built from one the published
 * contract has already typed.
 *
 * Every chat request builds its headers as `EmbedChatRequestHeaders`, so a header
 * name outside `EMBED_CHAT_REQUEST_HEADERS` in `@nexus/types` does not compile —
 * that list is what the backend's CORS allowlist is checked against, and a header
 * it does not admit fails the browser's preflight and nowhere else. This turns the
 * typed map into the `Record<string, string>` `fetch` accepts, dropping a key that
 * was declared and left unset rather than sending it empty.
 */
export function toFetchHeaders(headers: EmbedChatRequestHeaders): Record<string, string> {
  const result: Record<string, string> = {}
  for (const [name, value] of Object.entries(headers)) {
    if (value !== undefined) result[name] = value
  }
  return result
}
